import Footer from 'components/footer/Footer';
import MainPage from 'navigation/pages/MainPage';
class Collections extends MainPage {
    getModulesMap() {
        return {
            footer: ['.footer', Footer]
        };
    }
}
export default Collections;
